import styled from "styled-components";

const Section = styled.section`

@media (min-width: 375px) {
  padding-top: 30px;
  padding-bottom: 30px;
}
@media (min-width: 768px) {
  padding-top: 60px;
  padding-bottom: 60px;
}
@media (min-width: 1440px) {
  padding-top: 60px;
  padding-bottom: 60px;
}

`;
export default Section;
